import gql from 'graphql-tag';

export default () => gql`
  query {
    getTenantTrafficType(dummy: "") {
      tenantDetailList {
        name
        value
      }
    }
  }
`;
